// Database of nouns for word association exercises
let NOUNS: string[] = [];

// Function to load nouns from the JSON file
async function loadNouns() {
  try {
    const response = await fetch('/nouns.json');
    const words = await response.json();
    NOUNS = words;
    console.log(`Loaded ${NOUNS.length} words`); // Add logging to verify word count
  } catch (error) {
    console.error('Error loading nouns:', error);
    // Fallback to a small set if loading fails
    NOUNS = ["abbey", "ability", "absence", "abundance", "acceptance"];
    console.log('Using fallback words due to error');
  }
}

// Load nouns when the module is imported
loadNouns();

/**
 * Get random nouns from the database
 * @param count Number of random nouns to return
 * @returns Array of random nouns
 */
export function getRandomNouns(count: number): string[] {
  const shuffled = [...NOUNS].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

// Export NOUNS array for direct access if needed
export { NOUNS };
